export default __webpack_public_path__ + "static/media/evaluation.09dc549d.svg";